module.exports = __webpack_public_path__ + "img/surveyEmoji5.ed10c83d.svg";